module.exports = __webpack_public_path__ + "static/media/9.6160a7f9.jpg";